var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLearnActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 4V10.192L9.5 9L11.5 10.192V4H7.5ZM17.5 21.692C16.386 21.692 15.441 21.304 14.665 20.528C13.8883 19.752 13.5 18.8067 13.5 17.692C13.5 16.5787 13.8913 15.6337 14.674 14.857C15.4567 14.0803 16.4307 13.692 17.596 13.692C18.6587 13.692 19.5753 14.0803 20.346 14.857C21.1167 15.6337 21.5013 16.5787 21.5 17.692C21.5 18.8067 21.112 19.752 20.336 20.528C19.5593 21.304 18.614 21.692 17.5 21.692ZM16.635 19.577L19.365 17.654L16.635 15.731V19.577ZM11.5 17.691C11.5 18.2843 11.5837 18.8597 11.751 19.417C11.9183 19.975 12.1617 20.5027 12.481 21H5.616C5.17133 21 4.791 20.8417 4.475 20.525C4.159 20.2083 4.00067 19.8287 4 19.386V4.615C4 4.171 4.15833 3.791 4.475 3.475C4.79167 3.159 5.17167 3.00067 5.615 3H16.385C16.829 3 17.209 3.15833 17.525 3.475C17.841 3.79167 17.9993 4.17167 18 4.615V11.723C17.9327 11.719 17.865 11.7163 17.797 11.715C17.7297 11.713 17.6623 11.712 17.595 11.712C15.9083 11.712 14.4707 12.2927 13.282 13.454C12.0933 14.6153 11.4993 16.0283 11.5 17.691Z",
    fill: "url(#paint0_linear_26_830)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_26_830",
    x1: 4,
    y1: 12.346,
    x2: 21.5,
    y2: 12.346,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C6FF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F466C8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLearnActive);
export default __webpack_public_path__ + "static/media/learn-active.156745ad663db925251592529de0a491.svg";
export { ForwardRef as ReactComponent };